<template>
    <div>
        <div>
            <validation-observer ref="AddTemplateForm" #default="{ invalid }">
                <b-form @submit.prevent="formSubmitted">
                    <b-row>
                        <b-col md="12">
                            <b-form-group label="Template Name" label-for="mc-Template-name">
                                <validation-provider #default="{ errors }" name="Name" vid="Name" rules="required">
                                    <b-form-input id="mc-Template-name" placeholder="Template Name"
                                        v-model="template.name" />
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                            </b-form-group>
                        </b-col>
                        <b-col md="12">
                            <b-form-group label="Platform Type" label-for="platform-type">
                                <validation-provider rules="required" #default="{ errors }" name="Platform Type" vid="Platform Type">
                                    <v-select
                                        v-model="template.platformType"
                                        :options="platformTypes"
                                        label="text"
                                        multiple
                                        :clearable="false"
                                        class="item-selector-title"
                                        placeholder="Select Platform Type"
                                        :state="errors.length > 0 ? false : null"
                                    />
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                            </b-form-group>
                        </b-col>
                        
                        <b-col cols="12" class="mb-2">
                            <b-form-group label="Subject" label-for="textarea-default">
                                <validation-provider #default="{ errors }" name="Subject" vid="Subject" >
                                    <b-form-input id="textarea-default" type="text" placeholder="Subject"
                                        v-model="template.subject" />
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                            </b-form-group>
                        </b-col>

                        <b-col cols="12" class="mb-2">
                            <span>Template Content</span>
                            <validation-provider #default="{ errors }" name="Content" vid="Content">
                                <quill-editor v-model="template.body" :options="editorOption">
                                    <div id="toolbar" slot="toolbar">
                                        <button class="ql-bold">Bold</button>
                                        <button class="ql-italic">Italic</button>
                                        <button class="ql-underline">Underline</button>
                                        <button class="ql-strike">Strike</button>
                                        <button class="ql-blockquote">Quote</button>
                                        <button class="ql-list" value="ordered"></button>
                                        <button class="ql-list" value="bullet"></button>
                                        <button class="ql-indent" value="-1"></button>
                                        <button class="ql-indent" value="+1"></button>
                                        <button class="ql-script" value="sub"></button>
                                        <button class="ql-script" value="super"></button>
                                        <button class="ql-background"></button>
                                        <select class="ql-font">
                                            <option selected="selected"></option>
                                            <option value="serif">serif</option>
                                            <option value="monospace">monospace</option>
                                        </select>
                                        <select class="ql-header">
                                            <option value="1">Heading 1</option>
                                            <option value="2">Heading 2</option>
                                            <option value="3">Heading 3</option>
                                            <option value="4">Heading 4</option>
                                            <option value="5">Heading 5</option>
                                            <option value="6">Heading 6</option>
                                            <option selected></option>
                                        </select>
                                        <select class="ql-align">
                                            <option selected></option>
                                            <option value="center"></option>
                                            <option value="right"></option>
                                            <option value="justify"></option>
                                        </select>
                                        <button class="ql-image">Image</button>
                                        <button class="ql-video">Video</button>
                                    </div>
                                </quill-editor>
                                <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                        </b-col>

                        <b-col cols="12" class="mb-2">
                            <b-form-group label="Upload Media" label-for="media-upload">
                                <b-form-file
                                id="media-upload"
                                multiple
                                :accept="acceptFileTypes"
                                @change="handleFileUpload"
                                ref="fileInput"
                            />                                
                            </b-form-group>
                        
                            <!-- Image Preview Section -->
                            <div v-if="previewImages.length" class="preview-container">
                                <h5>Selected Images:</h5>
                                <b-row>
                                    <b-col v-for="(image, index) in previewImages" :key="index" cols="2" class="mb-2">
                                        <b-card class="preview-card">
                                            <b-img 
                                                :src="image.src" 
                                                class="preview-image"
                                                alt="Preview Image"
                                            ></b-img>
                                            <b-button variant="danger" size="sm" class="mt-1 w-100" @click="removeImage(index)">
                                                Remove
                                            </b-button>
                                        </b-card>
                                    </b-col>
                                </b-row>
                            </div>
                        </b-col>
                        
                    </b-row>
                    <div>
                        <b-button type="submit" variant="primary" :disabled="invalid">Submit</b-button>
                    </div>
                </b-form>
            </validation-observer>
        </div>
    </div>
</template>

<script>
import {
    BRow,
    BCol,
    BFormGroup,
    BForm,
    BButton,
    BFormInput,
    BFormTextarea,
    BFormSelect,
    BFormCheckbox,
    BFormFile,
    BContainer,
    BCard,
    BCardText,
    BSpinner,
    BImg
} from "bootstrap-vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { FormWizard, TabContent } from "vue-form-wizard";
import { mapActions, mapGetters } from "vuex";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import { quillEditor } from "vue-quill-editor";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import VSelect from "vue-select";
export default {
    components: {
        BFormSelect,
        BFormFile,
        BFormGroup,
        BForm,
        BFormTextarea,
        BFormInput,
        FormWizard,
        BContainer,
        BButton,
        BFormCheckbox,
        BCard,
        TabContent,
        BRow,
        BCol,
        ToastificationContent,
        BCardText,
        BSpinner,
        quillEditor,
        ValidationProvider,
        ValidationObserver,
        BImg,
        VSelect
    },
    data() {
        return {
            template: {
                name: null,
                platformType: [],
                subject: null,
                body: null,
                isActive: true,
                mediaFiles: []
            },
            previewImages: [],
            platformTypes: [
            ],
            editorOption: {
                modules: {
                    toolbar: "#toolbar",
                },
            },
            acceptFileTypes: "image/*, video/*",
        };
    },
    methods: {
        ...mapActions("emailtemplate", ["addContentTemplateAction", "getPlatformTypeAction"]),
        async formSubmitted() {
            // Start the loader
            let loader = this.$swal({
                title: 'Processing...',
                text: 'Please wait while the template is being added',
                onOpen: () => {
                    this.$swal.showLoading();
                },
                allowOutsideClick: () => !this.$swal.isLoading(),
                buttonsStyling: false,
                showConfirmButton: false,
            });

            try {
            let payload = {
                name: this.template.name,
                platformTypeID: this.template.platformType.map(pt => pt.value),
                subject: this.template.subject,
                content: this.template.body,
                mediaDetails: [],
                description : "",
                mediaPaths: [],
                contentType: "",
                captions: {},
                templateType: '',
                files: this.template.mediaFiles.map(file => ({
                name: file.file.name,
                extension: file.file.name.split('.').pop(),
                data: file.src, 
                user: 'Current User',
                description: file.name || 'Uploaded file'
            }))
            };

            const response = await this.addContentTemplateAction(payload);
    
    if (response.data.data.success) {
        loader.close();
        this.success();
    } else {
        loader.close(); 
        this.$swal({
            title: 'Error!',
            html:response.data.data?.message || "Failed!",
            icon: 'error',
            customClass: {
                confirmButton: 'btn btn-primary',
            },
            buttonsStyling: false,
        });
    }

        } catch (error) {
            loader.close();
            this.error(error.response ? error.response.data : error.message);
        }
        },

        success() {
            this.$swal({
                title: 'Template Added!',
                text: 'You have successfully added the Template!',
                icon: 'success',
                customClass: {
                    confirmButton: 'btn btn-primary',
                },
                buttonsStyling: false,
            }).then(result => {
                if (result.value) {
                    this.$router.push({ name: 'content-templates' });
                }
            })
        },
        error(data) {
            let msg = null;
            if (data)
                msg = this.getErrorString(data);
            this.$swal({
                title: 'Error!',
                //text: msg ?? ' Failed!',
                html: msg ?? " Failed!",
                icon: 'error',
                customClass: {
                    confirmButton: 'btn btn-primary',
                },
                buttonsStyling: false,
            })
        },
        getErrorString(data) {
            let msg = null;
            if (data.errors) {
                let errors = data.errors;
                msg = "<div>";
                msg += "<p>Cannot post your request due to the following errors:</p>"
                for (var prop in errors) {
                    if (Object.prototype.hasOwnProperty.call(errors, prop) && prop !== "request") {
                        msg += "<p>";
                        msg += prop.replace("$.", "");
                        msg += ": ";
                        msg += errors[prop].toString().replace("$.", "");
                        msg += "</p>"
                    }
                }
                msg += "</div>";
            }
            else if (data.message) {
                msg = "<div>";
                msg += "<p>Cannot post your request due to the following errors:</p>"
                msg += data.message;
                msg += "</div>";
            }
            return msg;
        },
        async handleFileUpload(event) {
    const files = event.target.files;
    // Limit to 2 files
    if (files.length > 2) {
        alert("You can only upload up to 2 files.");
        event.target.value = ""; // Clear file input
        return;
    }
    
    this.template.mediaFiles = []; 
    this.previewImages = []; 

    for (let file of files) {
        const base64String = await this.convertToBase64(file);
        this.template.mediaFiles.push({
            name: file.name,
            src: base64String,
            file
        });
        this.previewImages.push({ name: file.name, src: base64String, file }); 
    }

    console.log("Base64 Encoded Images:", this.template.mediaFiles); 
},

    removeImage(index) {
        this.template.mediaFiles.splice(index, 1);
        const removedFile = this.previewImages.splice(index, 1)[0].file; 

        let dataTransfer = new DataTransfer();
        this.previewImages.forEach((image) => {
            if (image.file !== removedFile) {
                dataTransfer.items.add(image.file);
            }
        });

        this.$refs.fileInput.files = dataTransfer.files;
    },

    convertToBase64(file) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file); 
            reader.onload = () => resolve(reader.result);
            reader.onerror = (error) => reject(error);
        });
    }
    },
    async mounted() {
        try {
        const platformData = await this.getPlatformTypeAction();
        console.log("Fetched platform types:", platformData);

        if (platformData) {
            this.platformTypes = platformData.map(item => ({
                value: item.id,   
                text: item.platform 
            }));
            console.log("Processed platform types:", this.platformTypes); 
        } else {
            console.error("Invalid platform data:", platformData);
        }
    } catch (error) {
        console.error("Error fetching platform types:", error);
    }
}

};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-wizard.scss";
@import "@core/scss/vue/libs/vue-good-table.scss";
@import "@core/scss/vue/libs/quill.scss";
</style>

<style scoped>
label {
    font-size: 1.714rem !important;
    font-weight: 500;
    margin-bottom: 0;
}
.preview-container {
    margin-top: 10px;
}

.preview-card {
    text-align: center;
    padding: 10px;
    border-radius: 8px;
    box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);
}

/* Fixed size for images */
.preview-image {
    width: 100px; 
    height: 100px; 
    object-fit: cover;
    border-radius: 5px; 
}

@media (max-width: 768px) {
    .preview-image {
        width: 80px;
        height: 80px;
    }
}
</style>